import { getFiles } from "@/entities/DataAssociation/DataAssociation.queries";
import {
    DocumentType,
    FileSnapshot,
    StatementType,
} from "@/entities/DataAssociation/File.model";
import { useApiQuery } from "@/api/hooks/useApiQuery";
import { useMemo } from "react";
import { useAtomValue } from "jotai";
import {
    fileListStatusOptionsAtom,
    fileListStatementTypeAtom,
} from "../Labeling.state";
import { FileStatusOptions } from "../Labeling.types";
// import { files as filesDummy } from "@/entities/DataAssociation/dummies/GET_Files.dummy";

export function useFileList() {
    const res = useApiQuery(getFiles);
    const status = useAtomValue(fileListStatusOptionsAtom);
    const statementType = useAtomValue(fileListStatementTypeAtom);
    console.log("statementType", statementType);
    console.log("status", status);

    const cleanedFiles = useMemo(() => {
        if (!res.data) return [];
        return res.data.filter(
            (file) => file.documentType === DocumentType.CLEANED,
        );
    }, [res.data]);

    const labeledFiles = useMemo(() => {
        if (!res.data) return [];
        return res.data.filter(
            (file) => file.documentType === DocumentType.LABELED,
        );
    }, [res.data]);

    const unlabeledFiles = useMemo(() => {
        if (!cleanedFiles.length) return [];
        return cleanedFiles.filter(
            (file) =>
                !labeledFiles.find(
                    (labeledFile) => labeledFile.producedFromFile === file.id,
                ),
        );
    }, [cleanedFiles, labeledFiles]);

    const files = useMemo(() => {
        if (status === FileStatusOptions.CLEANED) return cleanedFiles;
        else if (status === FileStatusOptions.UNLABELED) return unlabeledFiles;
        else if (status === FileStatusOptions.LABELED) return labeledFiles;
        else if (status === FileStatusOptions.ALL) return res.data;
        else return [];
    }, [cleanedFiles, labeledFiles, unlabeledFiles, res.data, status]);

    const filteredFiles: FileSnapshot[] = useMemo(() => {
        if (!files) return [];
        if (statementType === "all") return files;
        return files.filter(
            (file) =>
                file.documentKind ===
                (statementType as unknown as StatementType),
        );
    }, [files, statementType]);

    return {
        files: filteredFiles,
        unlabeledFiles: unlabeledFiles,
        labeledFiles: labeledFiles,
        cleanedFiles: cleanedFiles,
        allFiles: files,
        isLoading: res.isLoading,
        isError: res.isError,
    };
}
